export enum KinType {
  'Ingen' = 0,
  'Ægtefælle' = 1,
  'Samboende' = 2,
  'Kæreste' = 3,
  'Forældre' = 4,
  'Søskende' = 5,
  'SønDatter' = 6,
  'Ven' = 7,
  'Bekendt' = 8
}

export class Address {
  street: string
  zipCode: string
  city: string
  country: string

  constructor (street: string, zipCode: string, city: string, country:string) {
    this.street = street
    this.zipCode = zipCode
    this.city = city
    this.country = country
  }
}

export class NextOfKin {
  name: string
  address: Address
  kinType: KinType
  phoneNumber: string
  email?: string

  constructor (name: string, address: Address, kinType: KinType, phoneNumber: string, email: string | undefined) {
    this.name = name
    this.address = address
    this.kinType = kinType
    this.phoneNumber = phoneNumber
    this.email = email
  }
}

export default class Employee {
    employeeNumber: number
    name: string
    dateOfBirth: Date
    address: Address
    phoneNumber: string
    email?: string
    kin: NextOfKin
    socialSecurityNumber?: string

    constructor (employeeNumber: number, name: string, dateOfBirth: Date, address: Address, nextOfKin: NextOfKin, phoneNumber: string, email: string | undefined, socialSecurityNumber: string | undefined) {
      this.employeeNumber = employeeNumber
      this.name = name
      this.dateOfBirth = dateOfBirth
      this.address = address
      this.kin = nextOfKin
      this.socialSecurityNumber = socialSecurityNumber
      this.phoneNumber = phoneNumber
      this.email = email
    }
}
